import { TableCell, TableRow, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { GraphicsDuckImage } from '../../images';
import { ReactNode } from 'react';

export function NoResultsRow({ colSpan, text }: { colSpan: number; text: ReactNode }) {
  return (
    <TableRow>
      <TableCell variant="subhead" colSpan={colSpan}>
        <Stack direction="column" alignItems="center">
          {__BRIGHTY__ ? <GraphicsDuckImage width={120} height={120} /> : null}
          <Typography color="text.secondary">{text}</Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
